module.exports = __webpack_public_path__ + "static/media/pkr_background.70141d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/pkr_background.png
// module id = 2635
// module chunks = 0